import * as React from "react"

//https://react-svgr.com/playground/
function SvgIconCoupons(props) {
    return (
        <svg
            width={37}
            height={26}
            viewBox="0 0 37 26"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            {...props}
        >
            <path
            d="M35 19.415h1.337c0-.67-.495-1.235-1.157-1.325L35 19.415zm0-8.987l.18 1.325a1.337 1.337 0 001.157-1.325H35zM6.924 8.518c0-.74.599-1.338 1.337-1.338V4.506a4.01 4.01 0 00-4.01 4.011h2.673zm0 12.808V8.517H4.25v12.81h2.674zm1.337 1.337a1.337 1.337 0 01-1.337-1.337H4.25a4.01 4.01 0 004.01 4.011v-2.674zm24.065 0H8.261v2.674h24.065v-2.674zm1.337-1.337c0 .738-.599 1.337-1.337 1.337v2.674a4.01 4.01 0 004.01-4.01h-2.673zm0-1.911v1.911h2.674v-1.911h-2.674zm1.517-1.325c-1.722-.233-2.947-1.613-2.947-3.168h-2.674c0 3.018 2.342 5.422 5.261 5.818l.36-2.65zm-2.947-3.168c0-1.556 1.225-2.935 2.947-3.169l-.36-2.65c-2.919.396-5.261 2.8-5.261 5.819h2.674zm1.43-6.405v1.911h2.674v-1.91h-2.674zM32.326 7.18c.738 0 1.337.599 1.337 1.337h2.674a4.01 4.01 0 00-4.01-4.01V7.18zm-24.065 0h24.065V4.506H8.261V7.18z"
            fill="#000"
            />
            <path
            d="M5.946 20.157H4.674A2.674 2.674 0 012 17.483V4.673A2.674 2.674 0 014.674 2h24.065a2.674 2.674 0 012.674 2.674V5.74"
            stroke="#000"
            strokeWidth={2.674}
            />
            <path
            stroke="#000"
            strokeWidth={2.228}
            strokeLinecap="round"
            strokeDasharray="3.57 3.57"
            d="M10.288 9.915v10.013"
            />
            <path
            transform="matrix(-.59354 .8048 -.83353 -.55247 23.145 9.557)"
            stroke="#000"
            strokeWidth={2.674}
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M1.337-1.337h9.811"
            />
            <ellipse
            cx={16.706}
            cy={12.541}
            rx={1.793}
            ry={1.7}
            stroke="#000"
            strokeWidth={2.228}
            />
            <ellipse
            cx={24.598}
            cy={17.302}
            rx={1.793}
            ry={1.7}
            stroke="#000"
            strokeWidth={2.228}
            />
        </svg>
    )
}

export default SvgIconCoupons;